<section class="blue-card p-6 h-full mb-6">
  <dl class="flex flex-wrap">
    <div class="flex flex-col justify-between w-full">

      <div class="flex justify-between w-full mb-6">
        <h2 class="text-xl text-secondary-900 dark:text-white font-semibold">Special box for startups looking for investors</h2>
      </div>

      <div *ngIf="company">

        <!--
        <p class="text-md text-secondary-900 dark:text-white">
          {{ company | getAssistantPrompt: 'ASK_ASSISTANT_SPECIAL_INFORMATION' ?? '' }}
        </p>
        -->

        <app-assistant-prompt tag="ASK_ASSISTANT_SPECIAL_BOX"
                              title="Special information"
                              [type]="'special-box'"
                              [company]="company"
                              [reportId]="reportSearch?.id">
        </app-assistant-prompt>

      </div>

    </div>
  </dl>
</section>
